import cloneDeep from 'lodash/cloneDeep';

import { sortCaseInsensitive } from 'pages/utils/sort';

export const keyExists = (object) => (key) => key in object;

export const formatOptions = (options, idName) =>
  options
    .filter((option) => !option.archived)
    .map((option) => ({
      value: option[idName],
      label: option.name,
    }))
    .sort((a, b) => sortCaseInsensitive(a.label, b.label));

export const VENDOR_RETURN_PATH = '/inventory/vendor-returns/:id';

export const setBreadcrumbs = ({ text, ...rest }) => {
  const crumbs = [
    {
      type: 'ui_tab',
      title: 'Inventory',
      text: 'Inventory',
      name: 'inventory',
    },
    {
      title: 'Vendor returns',
      text: 'Vendor returns',
      name: 'vendor_return.listings.vendor_returns',
      type: 'listing',
    },
    {
      title: text,
      text,
      name: 'vendor_return.views.vendor_return',
      type: 'view',
      path: `${location.pathname}${location.search}`,
      ...rest,
    },
  ];

  window.merchantos.asyncSubscribe.notifySubscribers('react.mount.topbar', {
    props: {
      crumbs,
    },
  });

  if (window.breadcrumbs && window.breadcrumbs.length === 2) {
    /* The current page doesn't exist in the breadcrumb so we duplicate the listing */
    window.breadcrumbs.push(cloneDeep(crumbs[2]));
  } else {
    /* If we refresh the page */
    window.breadcrumbs = crumbs;
  }
};

export const guiDefsAddItem = ({ value, vendorReturnID, shopID, vendorID, onDone }) => {
  window.doServerCall(
    {
      method: 'POST',
      form_name: 'view.dofunction',
      return_to_parent: true,
      ajax_view: JSON.stringify({
        rec_num: vendorReturnID,
        name: 'vendor_return.views.vendor_return',
        record_id: vendorReturnID,
        tab: 'main',
        request: false,
        go_back: -1,
        type: 'view',
        path: `/inventory/vendor-returns/${vendorReturnID}`,
      }),
      fnc: 'add_item_to_vr_fnc',
      key_values: JSON.stringify({
        view_id: '',
        primary_id: vendorReturnID,
        shop_id: shopID,
        vendor_id: vendorID,
        add_item_search: value,
        add_item_show_all: 'off',
      }),
      pannel_id: 'view',
    },
    (data) => {
      // That means that the search is an exact match and item is added,
      // we should then re-fetch the VR and update the item listing
      if (data.refresh) {
        onDone();
      } else {
        // Go to gui-def item select page
        window.cb_doviewfunction(data);
      }
    }
  );
};
